import { SERVICES } from "../lib/data";
import { ArrowUpRight } from "lucide-react";

export default function ServicesGrid({ compact = false }) {
  return (
    <section data-testid="services-grid" className="py-24 lg:py-32 bg-[#F4F7FA] relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="kicker">What We Do</div>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-black text-navy tracking-tight">
            Comprehensive safety services<br />for every operational layer.
          </h2>
          {!compact && (
            <p className="mt-5 text-lg text-slate-600 max-w-2xl">
              From routine compliance audits to high-stakes risk assessments — engineered
              programs that protect people, plants and reputations.
            </p>
          )}
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.slug}
                data-testid={`service-card-${s.slug}`}
                className="card-hover group relative bg-white border border-navy/10 rounded-2xl p-8"
              >
                <div className="flex items-start justify-between">
                  <div className="h-14 w-14 rounded-xl bg-navy text-white flex items-center justify-center group-hover:bg-safety transition-colors">
                    <Icon className="h-7 w-7" />
                  </div>
                  <span className="font-heading text-sm font-bold text-steel-dark/40">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-heading text-2xl font-bold text-navy leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">{s.desc}</p>
                <a
                  href="#contact"
                  data-testid={`service-card-link-${s.slug}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-navy font-medium text-sm group-hover:text-safety transition-colors"
                >
                  Enquire <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
